import {ref} from 'vue';

export default {
    install: (app, options) => {
        const regions = ref([]);
        const salesRegions = ref([]);
        const geographicRegions = ref([]);

        const loadRegions = (urlParameters) => {
            const defaultUrlParameters = {
                all: true,
                category: '',
                from: '',
                with: '',
            };

            urlParameters = Object.assign(defaultUrlParameters, urlParameters)

            const urlSearchParams = new URLSearchParams(urlParameters);

            window.lazy_axios.get(`/regions/?${urlSearchParams.toString()}`)
                .then((response) => {
                    if (response.data.regions && response.data.regions.data) {
                        switch (urlParameters.category) {
                            case 'sales-regions':
                                salesRegions.value = response.data.regions.data;
                                break;

                            case 'geographic-regions':
                                geographicRegions.value = response.data.regions.data;
                                break;

                            default:
                                regions.value = response.data.regions.data;
                                break;
                        }
                    }
                });
        };

        app.provide('regions', regions);
        app.provide('regions.sales_regions', salesRegions);
        app.provide('regions.geographic_regions', geographicRegions);
        app.provide('loadRegions', loadRegions);
    },
}
